/**
 * In SCORM mode, ask the parent SCORM package to fetch the learner's KPIs and
 * commit score and status to the LMS. `save-kpis` carries the Domoscio uid for
 * this call (needed when the LMS uid is not the Domoscio one, e.g. MQB SSO).
 * The legacy 'commit' string stays for packages already uploaded in an LMS.
 * @param isScorm - true when Lock runs inside a SCORM package
 * @param studentUid - the learner's Domoscio uid, used only for this call
 */
export const postScormCommit = (isScorm: boolean, studentUid?: string | number | null) => {
  if (!isScorm || typeof window === 'undefined' || !window.parent) return

  const hasStudentUid = studentUid !== undefined && studentUid !== null && String(studentUid) !== ''

  if (hasStudentUid) {
    window.parent.postMessage({ type: 'save-kpis', student_uid: String(studentUid) }, '*')
  }

  window.parent.postMessage('commit', '*')
}
